function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9kZXZpY2VzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9kZXZpY2VzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBEZXZpY2VzKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aCBkPVwiTTI2LjEgNEgxMS4zMWExLjg0IDEuODQgMCAwMC0xLjg1IDEuODNWMTBINmEyIDIgMCAwMC0yIDJ2MTRhMiAyIDAgMDAyIDJoMjAuMWExLjg0IDEuODQgMCAwMDEuOS0xLjgzVjUuODNBMS44NCAxLjg0IDAgMDAyNi4xIDR6TTEzIDEzLjV2MTFhLjUuNSAwIDAxLS41LjVoLTZhLjUuNSAwIDAxLS41LS41di0xMWEuNS41IDAgMDEuNS0uNWg2YS41LjUgMCAwMS41LjV6TTI2IDI2SDE1VjEyYTIgMiAwIDAwLTItMmgtMS41NFY2SDI2elwiIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkRldmljZXMucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBEZXZpY2VzO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Devices(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    fill: primaryColor,
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M26.1 4H11.31a1.84 1.84 0 00-1.85 1.83V10H6a2 2 0 00-2 2v14a2 2 0 002 2h20.1a1.84 1.84 0 001.9-1.83V5.83A1.84 1.84 0 0026.1 4zM13 13.5v11a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h6a.5.5 0 01.5.5zM26 26H15V12a2 2 0 00-2-2h-1.54V6H26z"
  }));
}

Devices.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Devices;